import { CDN_URL, CDN_URL_IMAGES } from '@/configs';
import s from './style.module.scss';
import { ROUTE_PATH } from '@/constants/route-path';

export const Section3 = () => {
  return (
    <div
      className={`${s.container}`}
      style={{
        backgroundImage: `url(${CDN_URL_IMAGES}/home_bg_02.png)`,
      }}
    >
      <div className={s.wrapContainer}>
        <div className={s.leftContainer}>
          <div className={s.content}>
            <div className={s.row}>
              <p className={s.title}>{`GM & Souls`}</p>
            </div>
            <p className={s.desc}>
              GM and Souls are two halves of a single artwork that is the
              historical symbol of New Bitcoin City.
            </p>
            <a href={`${ROUTE_PATH.SOULS}/adopt`} className={s.wrap_link}>
              <p>Adopt a Soul</p>
            </a>
          </div>
        </div>
        <div className={s.rightContainer}>
          <div className={s.wrapBanner}>
            <video
              className={s.banner}
              id="homeVideo"
              autoPlay
              muted
              playsInline
              loop
              preload="auto"
            >
              <source
                src={
                  'https://storage.googleapis.com/tc-cdn-prod/nbc/videos/souls_mobile.mp4'
                }
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};
